const value = {
    successTitle: 'Success (from 70 to 100%)',
    successSubtitle: 'All answers are correct',
    neutralTitle: 'Fine (from 50 to 69%)',
    neutralSubtitle: 'More than 50% of answers are correct, but there is at least one mistake',
    failedTitle: 'Fail (from 0 to 49%)',
    failedSubtitle: 'More than 50% of answers are incorrect',
  };

export default value;
